namespace TabAurous.ECommerce {
    export interface ECommOrderRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        PartyId?: number;
        POSCustomerId?: number;
        FirstName?: string;
        LastName?: string;
        PosCustomerCode?: string;
        CustomerName?: string;
        PanNumber?: string;
        TermsId?: number;
        BaseItemTypeId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        ReceiptAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: ECommOrderItemsRow[];
        AddressDetails?: ECommOrderAddressRow[];
        ReceiptDetails?: ReceiptDetailsRow[];
        ECommOrderId?: number;
        ECommOrderNo?: string;
        ReasonId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        CheckList?: OrderManagementCheckListRow[];
        OrderStatusId?: number;
        OrderStatusName?: string;
        ProductItemImage?: string;
        Email?: string;
        Mobile?: string;
        PromoDetails?: ECommOrderPromoRow[];
        BillingCityName?: string;
        BillingCity?: number;
        BillingState?: number;
        BillingStateName?: string;
        BillingCountry?: number;
        BillingCountryName?: string;
        BillingAddress?: string;
        BillingPin?: string;
        BillingPhone?: string;
        ShippingAddress?: string;
        ShippingCity?: number;
        ShippingCityName?: string;
        ShippingState?: number;
        ShippingStateName?: string;
        ShippingCountry?: number;
        ShippingCountryName?: string;
        ShippingPincode?: string;
        ShippingPhone?: string;
    }

    export namespace ECommOrderRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'ECommerce.ECommOrder';
        export const deletePermission = 'EComm:ECommOrder:Delete';
        export const insertPermission = 'EComm:ECommOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommOrder:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            FirstName = "FirstName",
            LastName = "LastName",
            PosCustomerCode = "PosCustomerCode",
            CustomerName = "CustomerName",
            PanNumber = "PanNumber",
            TermsId = "TermsId",
            BaseItemTypeId = "BaseItemTypeId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            ReceiptAmount = "ReceiptAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            AddressDetails = "AddressDetails",
            ReceiptDetails = "ReceiptDetails",
            ECommOrderId = "ECommOrderId",
            ECommOrderNo = "ECommOrderNo",
            ReasonId = "ReasonId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            CheckList = "CheckList",
            OrderStatusId = "OrderStatusId",
            OrderStatusName = "OrderStatusName",
            ProductItemImage = "ProductItemImage",
            Email = "Email",
            Mobile = "Mobile",
            PromoDetails = "PromoDetails",
            BillingCityName = "BillingCityName",
            BillingCity = "BillingCity",
            BillingState = "BillingState",
            BillingStateName = "BillingStateName",
            BillingCountry = "BillingCountry",
            BillingCountryName = "BillingCountryName",
            BillingAddress = "BillingAddress",
            BillingPin = "BillingPin",
            BillingPhone = "BillingPhone",
            ShippingAddress = "ShippingAddress",
            ShippingCity = "ShippingCity",
            ShippingCityName = "ShippingCityName",
            ShippingState = "ShippingState",
            ShippingStateName = "ShippingStateName",
            ShippingCountry = "ShippingCountry",
            ShippingCountryName = "ShippingCountryName",
            ShippingPincode = "ShippingPincode",
            ShippingPhone = "ShippingPhone"
        }
    }
}
